module.exports = __webpack_public_path__ + "img/upgradeFail.8dc31e94.svg";